<template lang="html">

  <header class="header" @keyup.esc="showmenu = false">

    <section class="top row-between" :min="min">
      <router-link to="/" v-if="isLogged">
        <img width="" :src="`/static/img/${logo}`" alt="Logo UFV">
      </router-link>

      <router-link :to="$t('enlaces.empresas')" v-if="!isLogged">
        <img width="" :src="`/static/img/${logo}`" alt="Logo UFV">
      </router-link>

      <div class="right row-end">
        <h3 class="nombre">
          <router-link :to="$t('enlaces.cv')" v-if="isLogged & isCandidato">Hola, {{name}}</router-link>
          <router-link :to="$t('enlaces.miperfil')" v-if="isLogged & isEmpresa">Bienvenido, {{name}}</router-link>
        </h3>
        <button class="showmenu" @click="showmenu = !showmenu">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

    </section>

    <section class="bottom">

      <a href="tel:917091414" class="phone-icon">917091414</a>
      <a href="https://ufv-es.instructure.com/login/canvas" target="_blank">Contacta con nosotros</a>

    </section>

    <nav class="menu column-center" :show="showmenu">


      <button class="closemenu" @click="showmenu = !showmenu">✕</button>

      <router-link to="/" v-if="isLogged & isCandidato">Home</router-link>
      <router-link :to="$t('enlaces.empresas')" v-if="!isLogged">Inicio</router-link>
      
      <template v-if="isCandidato">   
        <router-link :to="$t('enlaces.cv')">Mi CV</router-link>
        <a class="father" :open="childs.practicas" @click="childs.practicas = !childs.practicas">{{isEstudiante ? 'Prácticas' : 'Empleo'}}</a>
        <div class="child column-start" v-show="childs.practicas">
          <router-link :to="$t('enlaces.ofertas')">Ofertas</router-link>
          <router-link :to="$t('enlaces.candidaturas')">Mis candidaturas</router-link>
          <router-link v-if="isEstudiante" :to="$t('enlaces.practicasasignadas')">Mis prácticas asignadas</router-link>
        </div>
         <router-link :to="$t('enlaces.estudiaytrabaja')" v-if="isEstudiante">Programa estudia y trabaja</router-link>
         <router-link :to="$t('enlaces.propuestapracticas')" v-if="isEstudiante">Propuesta de prácticas</router-link>
         <router-link :to="$t('enlaces.eventos')">Eventos</router-link>
         <router-link :to="$t('enlaces.orientacionprofesional')">Orientación</router-link>
      </template>

      <template v-if="isEmpresa">
        <router-link :to="$t('enlaces.informaciongeneral')">Información general</router-link>
        <router-link :to="$t('enlaces.contacto')">Contacto</router-link>
        <router-link to="/" v-if="isLogged">Home</router-link>
        <router-link :to="$t('enlaces.miperfil')">Mi perfil</router-link>
        <router-link :to="$t('enlaces.nuevaoferta')">Nueva oferta</router-link>
        <router-link :to="$t('enlaces.misofertas')+'/practicas'" >Ofertas de prácticas</router-link>
        <router-link :to="$t('enlaces.misofertas')+'/empleo'" >Ofertas de empleo</router-link>
        <router-link :to="$t('enlaces.busquedaCarta')">Búsqueda a la carta</router-link>
        <router-link :to="$t('enlaces.propuestapracticasempresa')">Propuesta de prácticas</router-link>
      </template>
      <router-link :to="$t('enlaces.encuestas')" v-if="isLogged">Encuestas</router-link>
      <router-link :to="$t('enlaces.testimonios')">Testimonios</router-link>
      <router-link :to="$t('enlaces.contacto')" v-if="isCandidato">Contacto</router-link>

      <router-link class="logout" :to="'/logout'" v-if="isLogged">Cerrar sesión</router-link>
      <router-link class="logout" :to="$t('enlaces.login')+'/empresas'" v-if="!isLogged">Entrar</router-link>
      <router-link :to="$t('enlaces.nuevaempresa')" v-if="!isLogged">Registrarme</router-link>

      
      
    </nav>
    
    <span :show="showmenu" class="cover" @click="showmenu = false"></span>

  </header>

</template>

<script lang="js">


import {mapGetters} from 'vuex';

  export default {
    name: 'app-header',
    mounted() {
      this.checkMinMenu()
      $(window).scroll(e => {
        this.checkMinMenu();
      });
    },
    data() {
      return {
        showmenu: false,
        min: false,
        childs: {
          practicas: false
        }
      }
    },
    methods: {
      checkMinMenu() {
        let top = $(window).scrollTop();
        let limit = $(".header").height() - 150;
        let difference = $(".header .top").height();

        this.min = (top > (limit - difference));
      }
    },
    computed:{
        ...mapGetters({
          isCandidato : 'isCandidato',
          isEstudiante : 'isEstudiante',
          isEmpresa : 'isEmpresa',
          isLogged : 'getLogged',
          name : 'getName'
        }),
        logo(){
          return (this.min) ? 'logo-pye-ufv-w.png' : 'logo-pye-ufv-w.png'
        }
    },
    watch: {
      '$route'() {
        this.showmenu = false;
        for (let i in this.childs) {
          this.childs[i] = false;
        }
      }
    },

  }
</script>


// WEBPACK FOOTER //
// src/components/parts/header.vue